import React, { useState, useEffect } from "react";
import santoshGiri from "../assets/images/board/santosh-giri.jpg";
import sailendraThapa from "../assets/images/board/sailendar-bikram-thapa.jpg";
import hariKharel from "../assets/images/board/hari-prassad-kharel.jpg";
import rudraKarki from "../assets/images/board/rudra-karki.jpg";
import laxmanBhandari from "../assets/images/board/laxman-bhandari.jpg";
import bishnuGhimire from "../assets/images/board/bishnu-prassad-ghimere.jpg";
import narishworGautam from "../assets/images/board/rishahor-gautam.jpg";
import milanGyawali from "../assets/images/board/milan-gyawali.jpg";
import tilakSripali from "../assets/images/board/tilak-bahadur-sripali.jpg";
import toyanathGautam from "../assets/images/board/toyanath-gautam.jpg";
import hariGhimire from "../assets/images/board/hari-prassad-ghimere.jpg";
import dipakKunwar from "../assets/images/board/dipak-kunwar.jpg";

const COMMITTEES = [
	{ key: "board", title: "संचालक समिति", className: "sanchalak samiti" },
	{ key: "accounts", title: "लेखा समिति", className: "lekha samiti" },
	{ key: "loan", title: "ऋण समिति", className: "lekha samiti" },
];

const POSITIONS = {
	chair: "अध्यक्ष",
	vice: "उपाध्यक्ष",
	secretary: "सचिव",
	treasurer: "कोषाध्यक्ष",
	convener: "संयोजक",
	member: "सदस्य",
};

// Shown only if the list cannot be loaded from the website's database.
// The real list is managed in the admin: Website content > Board and
// committee members.
const FALLBACK = [
	{ committee: "board", position: "chair", name: "सन्तोष गिरी", photo: santoshGiri },
	{ committee: "board", position: "vice", name: "शैलेन्द्र विक्रम थापा", photo: sailendraThapa },
	{ committee: "board", position: "secretary", name: "हरि प्रसाद खरेल", photo: hariKharel },
	{ committee: "board", position: "treasurer", name: "रुद्र कार्की", photo: rudraKarki },
	{ committee: "board", position: "member", name: "लक्ष्मण भण्डारी", photo: laxmanBhandari },
	{ committee: "board", position: "member", name: "विष्णु प्रसाद घिमिरे", photo: bishnuGhimire },
	{ committee: "board", position: "member", name: "नरिश्वर गौतम", photo: narishworGautam },
	{ committee: "accounts", position: "convener", name: "मिलन ज्ञवाली", photo: milanGyawali },
	{ committee: "accounts", position: "member", name: "तिलक श्रीपाली", photo: tilakSripali },
	{ committee: "accounts", position: "member", name: "तोयानाथ गौतम", photo: toyanathGautam },
	{ committee: "loan", position: "convener", name: "शैलेन्द्र विक्रम थापा", photo: sailendraThapa },
	{ committee: "loan", position: "member", name: "हरि प्रसाद घिमिरे", photo: hariGhimire },
	{ committee: "loan", position: "member", name: "दिपक कुँवर", photo: dipakKunwar },
].map((member, index) => ({ ...member, id: `fallback-${index}` }));

const Photo = ({ src, name }) => {
	const [failed, setFailed] = useState(false);
	if (!src || failed) {
		return (
			<div className='member-initial' aria-hidden='true'>
				{name.trim().charAt(0)}
			</div>
		);
	}
	return <img src={src} alt={name} onError={() => setFailed(true)} />;
};

const BoardMembers = () => {
	const [members, setMembers] = useState(null);

	useEffect(() => {
		fetch("/api/boardmembers/")
			.then((res) => {
				if (!res.ok) throw new Error(`HTTP ${res.status}`);
				return res.json();
			})
			.then((data) => {
				setMembers(Array.isArray(data) ? data : FALLBACK);
			})
			.catch((error) => {
				console.log(error);
				setMembers(FALLBACK);
			});
	}, []);

	return (
		<section className='eventspage-wrapper'>
			<h2>Board Members</h2>
			<div className='eventspage vision'>
				<article className='boardmembers-content'>
					{members === null && <p className='empty'>Loading...</p>}
					{members !== null &&
						COMMITTEES.map((committee) => {
							const people = members.filter(
								(member) => member.committee === committee.key
							);
							if (people.length === 0) return null;
							return (
								<div className={committee.className} key={committee.key}>
									<h3>{committee.title}</h3>
									<div className='members'>
										{people.map((member) => (
											<li key={member.id}>
												<Photo src={member.photo} name={member.name} />
												<p className='title'>
													<strong>{member.name}</strong>
												</p>
												<p className='post'>
													{POSITIONS[member.position] || member.position}
												</p>
											</li>
										))}
									</div>
								</div>
							);
						})}
				</article>
			</div>
		</section>
	);
};

export default BoardMembers;
